<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        
        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <!-- <a-col class="a-large-form">
            <a-form-item label="" style="margin-bottom:0px">
              <a-input placeholder="请输入姓名" style="width:100%" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form">
            <a-form-item label="" style="margin-bottom:0px">
              <a-input placeholder="请输入手机号" style="width:100%" v-model="queryParam.tel"></a-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-dbdate">
            <a-form-item label="" style="margin-bottom:0px">
              <a-range-picker style="width:100%" v-model="queryParam.time"/>
            </a-form-item>
          </a-col> -->
          
          <!-- <a-button type="primary" @click="searchQuery" style="margin-right:10px;margin-left:5px;">筛选</a-button> -->
          <a-button type="primary" @click="goodsCreate" icon="plus" style="margin-right:10px;float:right;">新增轮播</a-button>
          

        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">

          <!-- <a-popconfirm v-if="record.status==0" title="确定上架吗?" @confirm="() => goodsEnSale(record)">
            <a>上架</a>
          </a-popconfirm>
          <a-popconfirm v-if="record.status==1" title="确定下架吗?" @confirm="() => goodsUnSale(record)">
            <a>下架</a>
          </a-popconfirm>
          <a-divider type="vertical" /> -->
          <a @click="bannerEdite(record)">编辑</a>
          <a-divider type="vertical" />
          <!-- <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm> -->

          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          
        </span>
        <span slot="content" slot-scope="text, record">

          <img  :src="record.bannerPicUrl"  style="width:100px"/>
         
        </span>

        <span slot="jump" slot-scope="text, record">
            <span v-if="record.bannerType==0">-</span>
            <span v-else>
              <span v-if="record.jumpType==1">
                商品-{{record.jumpTargetName}}
              </span>
              <span v-if="record.jumpType==2">
                课程-{{record.jumpTargetName}}
              </span>
              <span v-if="record.jumpType==3">
                调剂
              </span>
              <span v-if="record.jumpType==4">
                估分
              </span>


              <!-- {{record.jumpType==2?():("课程"+recoerd.jumpTarget)}} -->
            </span>
        </span>

        

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <!-- <courseCreate-modal ref="modalForm" @ok="modalFormOk"/> -->

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  // import {operateDo} from '@/api/api';

  export default {
    name: "Feedback",
    mixins: [JeecgListMixin],
    components: {
      
    },
    data () {
      return {
        queryParam:{

          busiNo:"ListBanner"
          // name:"",
          // tel:""
        },


        description: '轮播导航',
        // 表头
        columns: [
         
          {
            title: '轮播图',
            align:"center",
            dataIndex: 'name',
            width:200,
            scopedSlots:{ customRender: 'content' },
          },
          {
            title: '轮播图名称',
            align:"center",
            dataIndex: 'bannerName',
            width:100
          },
          {
            title: '跳转链接',
            align:"center",
            // dataIndex: 'bannerPicUrl',
            width:260,
            scopedSlots:{ customRender: 'jump' },
            
          },
          
          // {
          //   title: '反馈时间',
          //   align:"center",
          //   dataIndex: 'createTime',
          //   width:180
          // },
          {
            title: "操作",
            align: "center",
            dataIndex: "op",
            width:160,
            scopedSlots: { customRender: 'action' }
          }
          
        ],
        dataSource:[
          
        ],
        // 请求参数
    	  url: {
              list: "/pc/operation/list",
              delete: "/pc/operation/delete",
              // deleteBatch: "/course/elinkxCourse/deleteBatch",
              // exportXlsUrl: "course/elinkxCourse/exportXls",
              // importExcelUrl: "course/elinkxCourse/importExcel",
           },
        }
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        }
      },


    methods: {

      goodsCreate(){
        this.$router.push({ path:'/operationsManagement/carouselCreate'});
      },
      bannerEdite(record){
        this.$router.push({ path:'/operationsManagement/carouselCreate?id='+record.id});
      },
      goodsEnSale(record){
        
        goodsEnSale({id:record.id}).then((res)=>{

          if(res.success==true){
            this.$message.warning(res.message);
            this.loadData()
          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      },
      goodsUnSale(record){
        
        goodsUnSale({id:record.id}).then((res)=>{
          
          if(res.success==true){
            this.$message.warning(res.message);
            this.loadData()
          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>